import { BrandHeader } from "@/components/game/BrandHeader";
import { Hero } from "@/components/game/Hero";
import { GameWizard } from "@/components/game/GameWizard";
import { CtaBanner } from "@/components/game/CtaBanner";
import { Footer } from "@/components/game/Footer";

const ticker = ["STRATEGY", "STORYTELLING", "REELS", "CAROUSELS", "STORIES", "CONTENT", "IMPACT"];

export default function Landing() {
  const start = () => document.getElementById("game")?.scrollIntoView({ behavior: "smooth" });
  return (
    <div data-testid="landing-page" className="overflow-x-hidden">
      <BrandHeader />
      <Hero onStart={start} />
      <div className="bg-[var(--gold)] text-[var(--green)] py-3 overflow-hidden -rotate-1">
        <div className="marquee flex whitespace-nowrap w-max">
          {[...ticker, ...ticker, ...ticker, ...ticker].map((t, i) => (
            <span key={i} className="mx-6 font-extrabold tracking-[0.2em] text-sm">{t} ✳</span>
          ))}
        </div>
      </div>
      <GameWizard />
      <CtaBanner />
      <Footer />
    </div>
  );
}
